// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import createElementDragPreviewShadows from './utils/createElementDragPreviewShadows';

// Selectors
import makeElementSelector from '../selectors/elementSelector';
import { getAttachment } from '../attachments/attachmentsSelector';

// Components
import Element from '../Element';

// Styles
import './ElementDragPreview.scss';

const mapStateToProps = createStructuredSelector({
    attachment: getAttachment,
});

@connect(makeElementSelector)
@connect(mapStateToProps)
class ElementDragPreview extends React.Component {
    constructor(props) {
        super(props);

        this.dragPreviewRef = React.createRef();
    }

    componentDidMount() {
        if (!this.dragPreviewRef || !this.dragPreviewRef.current) return;

        const dragHandle = this.dragPreviewRef.current.querySelector('.drag-handle');

        createElementDragPreviewShadows(dragHandle);
    }

    shouldComponentUpdate(nextProps) {
        return false;
    }

    render() {
        return (
            <div ref={this.dragPreviewRef} className="ElementDragPreview">
                <Element {...this.props} isDragging={false} isDragPreview />
            </div>
        );
    }
}

ElementDragPreview.propTypes = {
    currentBoardId: PropTypes.string.isRequired,
    element: PropTypes.object,
    className: PropTypes.string,
    dragOrigin: PropTypes.object,
};

export default ElementDragPreview;
